import styled from 'styled-components';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { zIndex } from 'tokens';
import { unthemed } from 'tokens';

// Share: always-blue pill, matches canonical share buttons app-wide
export const ShareButton = styled.button`
	display: flex;
	align-items: center;
	gap: 6px;
	box-sizing: content-box;
	padding: 6px 11px;
	height: 18px;
	margin-left: 8px;
	border-radius: 12px;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
	background: ${unthemed.blue[500]};
	border: 1px solid transparent;
	color: ${unthemed.gray[0]};
	font: inherit;

	&:hover {
		background: ${unthemed.blue[600]};
	}
	&:active {
		background: ${unthemed.blue[700]};
	}
	&:focus-visible {
		outline: 2px solid ${unthemed.blue[700]};
		outline-offset: 2px;
	}
`;

// Export: inverted — dark in light mode, light in dark mode.
// gray[1000] is the theme's darkest in light mode and lightest in dark mode,
// so using it for background flips relative to the rest of the island.
export const ExportButton = styled.button`
	all: unset;
	display: flex;
	align-items: center;
	gap: 6px;
	box-sizing: content-box;
	padding: 6px 11px;
	height: 18px;
	margin-left: 8px;
	border-radius: 12px;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
	background: ${({ theme }) => theme.gray[1000]};
	border: none;
	color: ${({ theme }) => theme.gray[0]};
	font: inherit;

	&:hover {
		background: ${({ theme }) => theme.gray[900]};
	}
	&:active {
		background: ${({ theme }) => theme.gray[800]};
	}
	&:focus-visible {
		outline: 2px solid ${({ theme }) => theme.blue[700]};
		outline-offset: 2px;
	}
`;

export const Chevron = styled.div<{ $open: boolean }>`
	display: flex;
	align-items: center;
	transition: transform 0.2s ease;
	transform: rotate(${({ $open }) => ($open ? '180deg' : '0deg')});
`;

export const ExportDropdownContent = styled(DropdownMenu.Content)`
	z-index: ${zIndex.contextMenu};
	background: ${({ theme }) => theme.gray[100]};
	border: 1px solid ${({ theme }) => theme.gray[400]};
	border-radius: 10px;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12), 0 0 1px rgba(0, 0, 0, 0.12);
	padding: 4px;
	min-width: 240px;
	overflow: hidden;
`;

export const ButtonLabel = styled.div<{ color: string }>`
	font-size: 14px;
	font-weight: 400;
	color: ${({ color }) => color};
`;

export const RenameOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 1;
`;

export const TitleText = styled.div`
	font-size: 14px;
	font-weight: 400;
	color: ${({ theme }) => theme.gray[1000]};
	max-width: 160px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	cursor: text;
`;

export const RenameInput = styled.span`
	font-size: 14px;
	font-weight: 400;
	color: ${({ theme }) => theme.gray[1000]};
	background: transparent;
	border: none;
	outline: none;
	padding: 0;
	margin: 0;
	font-family: inherit;
	white-space: pre;
	max-width: 240px;
	overflow: hidden;
	display: inline-block;
	min-width: 1ch;

	&::selection {
		background: ${({ theme }) => theme.blue[500]}33;
	}
`;
